<template>
  <v-layout row wrap fill-height>

    <!-- NEW VEHICLE -->
    <v-flex v-if="!inPage('new-vehicle')" shrink>
      <v-btn class="primary" @click="toVehicle()">
        <v-icon left class="subPrimary--text">directions_car</v-icon>
        <span class="subPrimary--text font-weight-light text-capitalize">{{ $t("Menu.Vehicles") }}</span>
      </v-btn>
    </v-flex>

    <!-- IF VEHICLE IS SELECTED -->
    <template v-if="this.isVehicleSelected">
      <!-- CATALOG -->
      <v-flex shrink v-if="!inPage('parts-lookup')">
        <v-btn class="primary" @click="toCatalog()">
          <v-icon left class="subPrimary--text">build</v-icon>
          <span class="subPrimary--text font-weight-light text-capitalize">{{ $t('Menu.Catalog') }}</span>
        </v-btn>
      </v-flex>

      <!-- INTERCHANGE -->
      <v-flex shrink>
        <Interchange :dark="true" />
      </v-flex>
    </template>

    <!-- DYNAMIC MENU -->
    <slot name="menu"></slot>

  </v-layout>
</template>

<script>
import { inPage, to } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "MenuDesktop",
  components: {
    Interchange: () => import("@/components/Interchange/Interchange"),
  },
  methods: {
    inPage,
    to,
    ...mapActions({
      RESET_PART_LIST: "parts/RESET_PART_LIST"
    }),
    toCatalog() {
      this.to('parts-lookup');
      this.RESET_PART_LIST()
    },
    toVehicle() {
      this.to('new-vehicle');
      this.RESET_PART_LIST()
    }
  },
  computed: {
    ...mapGetters({
      isVehicleSelected: "vehicle/isVehicleSelected",
    })
  }
};

</script>